import client from './client';

// 좌측 메뉴 "즐겨찾기" 그룹 — 서버에 저장되는 사용자별 즐겨찾기 메뉴 UUID 목록(순서 포함).
const BASE_URL = '/api/v1/common/menu-fav';

/** 로그인 사용자 본인의 즐겨찾기 메뉴 UUID 목록(저장된 순서대로). { list: [menuUuid, ...] } */
export const fetchMenuFavs = () => client.get(BASE_URL);

/** 즐겨찾기 목록을 통째로 교체(순서 포함)한다. */
export const saveMenuFavs = (menuUuids) => client.put(BASE_URL, { list: menuUuids });
